"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var validate_1 = require("./validate");
var util_1 = require("util");
function onlyIf(condition, validator) {
    return (function (value) {
        var shouldReturnValidationErrors = typeof condition === 'function' ? condition(value) : condition;
        return shouldReturnValidationErrors
            ? validator(value)
            : validate_1.valid;
    });
}
exports.onlyIf = onlyIf;
exports.requiredWithMessage = function (message) {
    return function (validator) {
        return function (val) {
            if ((val == null)
                || ((typeof val === 'string' || util_1.isArray(val)) && val.length === 0)) {
                return [message];
            }
            return validator ? validator(val) : validate_1.valid;
        };
    };
};
exports.required = exports.requiredWithMessage('Please complete this field');
exports.optional = function (validator) {
    return function (val) {
        if (val == null) {
            return [];
        }
        return validator(val);
    };
};
exports.rules = function () {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return function (value) { return lodash_1.flatMap(validators, function (validator) { return validator(value); }); };
};



//////////////////
// WEBPACK FOOTER
// ../composable-validation/dist/combinators.js
// module id = 32
// module chunks = 0